import styled from 'styled-components';

export const MyPageContainer = styled.div`
  ${({ theme }) => theme.container.mainContainer}
`;
